import { List, Record } from 'immutable';

export const System = new Record({
  id: null,
  isNew: true,
  isPending: false,
  items: new List(),
  data: null,
  error: null
});
